
export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-file-text-line',
      title: '税務申告',
      description: '法人税、所得税、消費税など各種税務申告を正確かつ迅速に対応いたします。',
      features: ['法人税申告', '所得税申告', '消費税申告', '相続税申告']
    },
    {
      icon: 'ri-calculator-line',
      title: '経理代行',
      description: '日々の経理業務を代行し、正確な帳簿作成と財務管理をサポートします。',
      features: ['記帳代行', '給与計算', '決算書作成', '財務分析']
    },
    {
      icon: 'ri-building-line',
      title: '会社設立支援',
      description: '新規事業立ち上げから法人設立まで、トータルサポートいたします。',
      features: ['定款作成', '登記手続き', '許認可申請', '設立後サポート']
    },
    {
      icon: 'ri-line-chart-line',
      title: '経営コンサルティング',
      description: '財務データを基にした経営改善提案と事業計画策定をお手伝いします。',
      features: ['経営分析', '事業計画策定', '資金調達支援', '業務改善提案']
    }
  ];

  return (
    <section id="services" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-3 sm:mb-4 px-2">
            事業案内
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            お客様のビジネスを支える幅広いサービスをご提供しています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8 px-2">
          {services.map((service, index) => (
            <div key={index} className="bg-gray-50 rounded-lg p-6 sm:p-8 hover:shadow-lg transition-shadow duration-300">
              <div className="flex items-start space-x-3 sm:space-x-4">
                <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-blue-600 text-white rounded-lg flex-shrink-0">
                  <i className={`${service.icon} text-lg sm:text-xl`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3 break-words">
                    {service.title}
                  </h3>
                  <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4 break-words">
                    {service.description}
                  </p>
                  <ul className="space-y-2">
                    {service.features.map((feature, featureIndex) => (
                      <li key={featureIndex} className="flex items-center text-xs sm:text-sm text-gray-600">
                        <div className="w-4 h-4 flex items-center justify-center mr-2 flex-shrink-0">
                          <i className="ri-check-line text-green-600"></i>
                        </div>
                        <span className="break-words">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
